<template>
  <div>
    <v-card
      class="mt-0"
      v-if="isStaff"
      shaped
      elevation="12"
      max-width="344"
      outlined
    >
      <v-list-item three-line>
        <v-autocomplete
          :label="label"
          prepend-inner-icon="search"
          v-model="selectedCaseReference"
          :items="cases"
          solo-inverted
          flat
          hide-details
          @change="getSelectedCase()"
        ></v-autocomplete>
      </v-list-item>
    </v-card>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
export default {
  props: ["label"],
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    isStaff() {
      return this.$store.getters.isStaff;
    },
  },
  mounted() {
    this.getAllCases();
  },
  data: () => ({
    cases: [],
    selectedCaseReference: null,
  }),
  methods: {
    getSelectedCase() {
      this.$emit("case-selected", this.selectedCaseReference);
    },
    getAllCases() {
      this.$store.commit("setLoader", true);
      axios
        .getData("/auth/get-all-cases", this.getAccessToken)
        .then((cases) => {
          this.cases = [];
          cases.forEach((caseObj) => {
            this.cases.push({
              text: `${caseObj.title} | ${caseObj.client.name} | ${caseObj.file_number} | ${caseObj.client_reference}`,
              value: caseObj.id,
            });
          });
          this.$store.commit("setLoader", false);
        });
    },
  },
};
</script>

<style></style>
